(function () {
  "use strict";

  class ProductCardReviewsComponent extends HTMLElement {
    constructor() {
      super();
      this._isConnected = false;
      this._needsRender = false;
      this._renderRAF = null;
      this._lastHTML = null;
    }

    // no-op helpers removed (debugging)

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      const originalPriceVal = parseFloat(value?.priceInfo?.originalPrice ?? 0);
      if (this._isConnected) {
        // Always render if we have a product, regardless of price
        if (value && originalPriceVal && originalPriceVal !== 0) {
          this._scheduleRender();
        } else if (value) {
          // Still render even if no originalPrice, but with empty reviews
          this._scheduleRender();
        } else {
          // Clear content when no product
          this.innerHTML = "";
          this._lastHTML = null;
          this._needsRender = false;
        }
      } else {
        this._needsRender = !!(value && originalPriceVal && originalPriceVal !== 0);
      }
    }

    connectedCallback() {
      this._isConnected = true;
      if (this._product && this._needsRender) {
        this._scheduleRender();
        this._needsRender = false;
      } else if (this._product && this._lastHTML == null) {
        this._scheduleRender();
      }
    }

    disconnectedCallback() {
      this._isConnected = false;
      if (this._renderRAF) {
        cancelAnimationFrame(this._renderRAF);
        this._renderRAF = null;
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (name === "product" && newVal && newVal !== oldVal) {
        try {
          const parsed = JSON.parse(newVal);
          this.product = parsed;
        } catch (e) {
          // ignore invalid JSON
        }
      }
    }

    _scheduleRender() {
      if (this._renderRAF) cancelAnimationFrame(this._renderRAF);
      this._renderRAF = requestAnimationFrame(() => {
        this._renderRAF = null;
        this._doRender();
      });
    }

    _doRender() {
      if (!this._product) {
        this.innerHTML = "";
        this._lastHTML = null;
        return;
      }

      const getNumericId = (gidOrId) =>
        typeof gidOrId === "string" && gidOrId.includes("/")
          ? gidOrId.split("/").pop()
          : String(gidOrId || "");

      const safeText = (val) => (val == null ? "" : String(val));
      
      // Handle and IDs
      const url = this._product?.url || "#";

      // Variants and selection
      const variants = Array.isArray(this._product?.variants)
        ? this._product.variants
        : [];
      const selectedVariantNumericId = safeText(this._product?.variantId || "");
      const selectedVariant =
        variants.find((v) => getNumericId(v.id) === selectedVariantNumericId) ||
        variants[0] ||
        null;

      // SKU for reviews and display (use selected or first variant, or fallback to productId)
      const sku = safeText(selectedVariant?.sku || variants[0]?.sku || this._product?.productId || "");
      const baseSku = sku.split(".")[0]?.split("-")[0] || sku;

      // Reviews block (Bazaarvoice) - always show, even if no baseSku
      const reviewsHtml = baseSku
        ? `<div class="start-reviews" data-bv-show="inline_rating" data-bv-product-id="${baseSku}" data-bv-redirect-url="${url}" data-bv-seo="false" data-bv-lang=""></div>`
        : `<div class="start-reviews" data-bv-show="inline_rating" data-bv-product-id="" data-bv-redirect-url="${url}" data-bv-seo="false" data-bv-lang=""></div>`;

      const html = `
        ${reviewsHtml}
      `;
      if (html !== this._lastHTML) {
        this.innerHTML = html;
        this._lastHTML = html;
      }
    }
  }

  customElements.define("rcc-product-card-reviews", ProductCardReviewsComponent);
})();
